import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const BarChartIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 15.6206V17.6206M12 11.6206V17.6206M16 7.62061V17.6206M7.8 21.6206H16.2C17.8802 21.6206 18.7202 21.6206 19.362 21.2936C19.9265 21.006 20.3854 20.5471 20.673 19.9826C21 19.3408 21 18.5008 21 16.8206V8.42061C21 6.74045 21 5.90037 20.673 5.25863C20.3854 4.69415 19.9265 4.23521 19.362 3.94759C18.7202 3.62061 17.8802 3.62061 16.2 3.62061H7.8C6.11984 3.62061 5.27976 3.62061 4.63803 3.94759C4.07354 4.23521 3.6146 4.69415 3.32698 5.25863C3 5.90037 3 6.74045 3 8.42061V16.8206C3 18.5008 3 19.3408 3.32698 19.9826C3.6146 20.5471 4.07354 21.006 4.63803 21.2936C5.27976 21.6206 6.11984 21.6206 7.8 21.6206Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </SvgIcon>
    );
}

export const ParentIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 19.6206V17.6206C21 15.7568 19.7252 14.1907 18 13.7466M14.5 1.91136C15.9659 2.50475 17 3.94192 17 5.62061C17 7.29929 15.9659 8.73646 14.5 9.32985M16 19.6206C16 17.7568 16 16.825 15.6955 16.0899C15.2895 15.1098 14.5108 14.3311 13.5307 13.9251C12.7956 13.6206 11.8638 13.6206 10 13.6206H7C5.13623 13.6206 4.20435 13.6206 3.46927 13.9251C2.48915 14.3311 1.71046 15.1098 1.30448 16.0899C1 16.825 1 17.7568 1 19.6206M12.5 5.62061C12.5 7.82974 10.7091 9.62061 8.5 9.62061C6.29086 9.62061 4.5 7.82974 4.5 5.62061C4.5 3.41147 6.29086 1.62061 8.5 1.62061C10.7091 1.62061 12.5 3.41147 12.5 5.62061Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

        </SvgIcon>
    );
}

export const HomeIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 17.6206H16M11.0177 3.3846L4.23539 8.65973C3.78202 9.01235 3.55534 9.18866 3.39203 9.40946C3.24737 9.60505 3.1396 9.82539 3.07403 10.0597C3 10.3241 3 10.6113 3 11.1857V18.4206C3 19.5407 3 20.1007 3.21799 20.5286C3.40973 20.9049 3.71569 21.2109 4.09202 21.4026C4.51984 21.6206 5.07989 21.6206 6.2 21.6206H17.8C18.9201 21.6206 19.4802 21.6206 19.908 21.4026C20.2843 21.2109 20.5903 20.9049 20.782 20.5286C21 20.1007 21 19.5407 21 18.4206V11.1857C21 10.6113 21 10.3241 20.926 10.0597C20.8604 9.82539 20.7526 9.60505 20.608 9.40946C20.4447 9.18866 20.218 9.01235 19.7646 8.65973L12.9823 3.3846C12.631 3.11135 12.4553 2.97472 12.2613 2.92221C12.0902 2.87587 11.9098 2.87587 11.7387 2.92221C11.5447 2.97472 11.369 3.11135 11.0177 3.3846Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

        </SvgIcon>
    );
}

export const CheckDoneIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 15.6206L8 17.6206L12.5 13.1206M8 8.62061V5.82061C8 4.7005 8 4.14045 8.21799 3.71262C8.40973 3.3363 8.71569 3.03034 9.09202 2.83859C9.51984 2.62061 10.0799 2.62061 11.2 2.62061H18.8C19.9201 2.62061 20.4802 2.62061 20.908 2.83859C21.2843 3.03034 21.5903 3.3363 21.782 3.71262C22 4.14045 22 4.7005 22 5.82061V13.4206C22 14.5407 22 15.1008 21.782 15.5286C21.5903 15.9049 21.2843 16.2109 20.908 16.4026C20.4802 16.6206 19.9201 16.6206 18.8 16.6206H16M5.2 22.6206H12.8C13.9201 22.6206 14.4802 22.6206 14.908 22.4026C15.2843 22.2109 15.5903 21.9049 15.782 21.5286C16 21.1008 16 20.5407 16 19.4206V11.8206C16 10.7005 16 10.1404 15.782 9.71262C15.5903 9.3363 15.2843 9.03034 14.908 8.83859C14.4802 8.62061 13.9201 8.62061 12.8 8.62061H5.2C4.0799 8.62061 3.51984 8.62061 3.09202 8.83859C2.71569 9.03034 2.40973 9.3363 2.21799 9.71262C2 10.1404 2 10.7005 2 11.8206V19.4206C2 20.5407 2 21.1008 2.21799 21.5286C2.40973 21.9049 2.71569 22.2109 3.09202 22.4026C3.51984 22.6206 4.07989 22.6206 5.2 22.6206Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

        </SvgIcon>
    );
}

export const PieChartIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.62061C13.3132 2.62061 14.6136 2.87926 15.8268 3.38181C17.0401 3.88436 18.1425 4.62095 19.0711 5.54954C19.9997 6.47813 20.7363 7.58052 21.2388 8.79378C21.7413 10.007 22 11.3074 22 12.6206M12 2.62061V12.6206M12 2.62061C6.47715 2.62061 2 7.09776 2 12.6206C2 18.1435 6.47715 22.6206 12 22.6206C17.5228 22.6206 22 18.1435 22 12.6206M12 2.62061C17.5228 2.62061 22 7.09776 22 12.6206M22 12.6206L12 12.6206M22 12.6206C22 14.1987 21.6265 15.7544 20.9101 17.1605C20.1936 18.5666 19.1546 19.7832 17.8779 20.7108L12 12.6206" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </SvgIcon>
    );
}

export const ExpandMoreIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon sx={{ width: '10px', height: '10px' }} {...props} viewBox="0 0 9 7">
            <svg fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.65419 5.82785C5.25394 6.32303 4.499 6.32302 4.09876 5.82784L1.06951 2.07999C0.540946 1.42604 1.00639 0.451378 1.84723 0.451378L7.90587 0.451379C8.74672 0.451379 9.21216 1.42606 8.68358 2.08L5.65419 5.82785Z" fill="currentColor" stroke="currentColor" />
            </svg>
        </SvgIcon>
    );
}

export const ExpandLessIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon sx={{ width: '10px', height: '10px' }} {...props} viewBox="0 0 9 7">
            <path
                d="M3.34581 1.17215C3.74606 0.676971 4.501 0.676976 4.90124 1.17216L7.93049 4.92C8.45905 5.57395 7.99361 6.54862 7.15277 6.54862H1.09413C0.253284 6.54862 -0.212163 5.57394 0.316417 4.92L3.34581 1.17215Z"
                fill="currentColor" stroke="currentColor"
            />
        </SvgIcon>
    );
}

export const LayoutRightIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon sx={{ cursor: 'pointer' }} {...props}>
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.75 2.58936V16.0894M12.15 2.58936H5.85C4.58988 2.58936 3.95982 2.58936 3.47852 2.83459C3.05516 3.05031 2.71095 3.39451 2.49524 3.81788C2.25 4.29918 2.25 4.92924 2.25 6.18936V12.4894C2.25 13.7495 2.25 14.3795 2.49524 14.8608C2.71095 15.2842 3.05516 15.6284 3.47852 15.8441C3.95982 16.0894 4.58988 16.0894 5.85 16.0894H12.15C13.4101 16.0894 14.0402 16.0894 14.5215 15.8441C14.9448 15.6284 15.289 15.2842 15.5048 14.8608C15.75 14.3795 15.75 13.7495 15.75 12.4894V6.18936C15.75 4.92924 15.75 4.29918 15.5048 3.81788C15.289 3.39451 14.9448 3.05031 14.5215 2.83459C14.0402 2.58936 13.4101 2.58936 12.15 2.58936Z" stroke="#475467" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </SvgIcon>
    );
}

export const LogoutIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><path d="M0 0h24v24H0z" fill="none" /><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" /></svg>
        </SvgIcon>
    );
};

export const EmailIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><path d="M0 0h24v24H0z" fill="none" /><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" /></svg>
        </SvgIcon>
    );
};

export const AccountCircleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><g><rect fill="none" height="24" width="24" /></g><g><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z" /></g></svg>
        </SvgIcon>
    );
};

export const VerifiedIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon fontSize="medium" {...props}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="8" cy="8" r="8" fill="transparent" />
                <path
                    d="M10.9331 5.59937L6.89974 9.99936L5.06641 7.99937"
                    stroke="#067647"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </SvgIcon>
    );
}

export const NotVerifiedIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon fontSize="medium" {...props}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="8" cy="8" r="8" fill="transparent" />
                <path
                    d="M10.3977 5.59985L5.59766 10.3999M5.59766 5.59985L10.3977 10.3999"
                    stroke="#B42318"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </SvgIcon>
    );
}

export const MailOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon fontSize="medium" {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3463_406212)">
          <path
            d="M17.8849 15.44L12.3714 10.46M7.62852 10.46L2.11498 15.44M1.69995 6.30996L8.47683 11.0538C9.02561 11.4379 9.29999 11.63 9.59845 11.7044C9.86208 11.7701 10.1378 11.7701 10.4015 11.7044C10.6999 11.63 10.9743 11.4379 11.5231 11.0538L18.3 6.30996M5.68395 17.1H14.316C15.7105 17.1 16.4077 17.1 16.9404 16.8286C17.4089 16.5898 17.7898 16.2089 18.0286 15.7404C18.3 15.2078 18.3 14.5105 18.3 13.116V7.80396C18.3 6.40943 18.3 5.71217 18.0286 5.17953C17.7898 4.711 17.4089 4.33008 16.9404 4.09136C16.4077 3.81996 15.7105 3.81996 14.316 3.81996H5.68395C4.28942 3.81996 3.59216 3.81996 3.05951 4.09136C2.59099 4.33008 2.21007 4.711 1.97134 5.17953C1.69995 5.71217 1.69995 6.40943 1.69995 7.80396V13.116C1.69995 14.5105 1.69995 15.2078 1.97134 15.7404C2.21007 16.2089 2.59099 16.5898 3.05951 16.8286C3.59216 17.1 4.28942 17.1 5.68395 17.1Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3463_406212">
            <rect
              width="19.92"
              height="19.92"
              fill="white"
              transform="translate(0.0400391 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export const PhoneOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon fontSize="medium" {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99567 7.84824C7.57335 9.05142 8.36084 10.1791 9.35815 11.1764C10.3555 12.1737 11.4831 12.9612 12.6863 13.5389C12.7898 13.5886 12.8416 13.6134 12.907 13.6325C13.1397 13.7003 13.4255 13.6516 13.6225 13.5105C13.678 13.4708 13.7254 13.4234 13.8203 13.3285C14.1105 13.0383 14.2556 12.8932 14.4015 12.7984C14.9517 12.4406 15.661 12.4406 16.2112 12.7984C16.3571 12.8932 16.5021 13.0383 16.7923 13.3285L16.9541 13.4902C17.3952 13.9313 17.6157 14.1519 17.7355 14.3887C17.9738 14.8598 17.9738 15.4161 17.7355 15.8872C17.6157 16.1241 17.3952 16.3446 16.9541 16.7857L16.8232 16.9166C16.3836 17.3561 16.1638 17.5759 15.865 17.7438C15.5334 17.9301 15.0184 18.064 14.6381 18.0629C14.2953 18.0618 14.0611 17.9954 13.5926 17.8624C11.0749 17.1478 8.69913 15.7995 6.71711 13.8174C4.73508 11.8354 3.38677 9.45967 2.67216 6.94195C2.53919 6.47346 2.47271 6.23921 2.47169 5.89646C2.47055 5.51614 2.60449 5.00113 2.79075 4.66954C2.95862 4.37072 3.17841 4.15092 3.618 3.71134L3.74884 3.5805C4.18993 3.1394 4.41048 2.91885 4.64735 2.79905C5.11843 2.56078 5.67475 2.56078 6.14582 2.79905C6.38269 2.91885 6.60324 3.1394 7.04433 3.5805L7.20607 3.74224C7.49625 4.03241 7.64133 4.1775 7.73619 4.3234C8.09392 4.87359 8.09392 5.5829 7.73619 6.1331C7.64133 6.27899 7.49625 6.42408 7.20607 6.71425C7.1112 6.80913 7.06376 6.85657 7.02405 6.91202C6.88294 7.10909 6.83422 7.39483 6.90205 7.62752C6.92113 7.693 6.94598 7.74475 6.99567 7.84824Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export const TwoFaOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon fontSize="medium" {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0001 12.535V7.55499M7.51011 10.045H12.4901M16.6401 10.46C16.6401 14.534 12.1963 17.4971 10.5794 18.4403C10.3957 18.5475 10.3038 18.6011 10.1741 18.6289C10.0735 18.6505 9.9267 18.6505 9.82607 18.6289C9.69641 18.6011 9.60453 18.5475 9.42078 18.4403C7.8039 17.4971 3.36011 14.534 3.36011 10.46V6.4906C3.36011 5.827 3.36011 5.49521 3.46864 5.20999C3.56452 4.95804 3.72031 4.73322 3.92256 4.55498C4.15151 4.35321 4.46218 4.23671 5.08352 4.00371L9.53382 2.33485C9.70637 2.27014 9.79265 2.23779 9.8814 2.22496C9.96013 2.21359 10.0401 2.21359 10.1188 2.22496C10.2076 2.23779 10.2938 2.27014 10.4664 2.33485L14.9167 4.00371C15.538 4.23671 15.8487 4.35321 16.0777 4.55498C16.2799 4.73322 16.4357 4.95804 16.5316 5.20999C16.6401 5.49521 16.6401 5.827 16.6401 6.4906V10.46Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export const CopyIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16699 11.9632C3.39042 11.9632 3.00214 11.9632 2.69585 11.8363C2.28747 11.6672 1.96302 11.3427 1.79386 10.9344C1.66699 10.6281 1.66699 10.2398 1.66699 9.46322V3.79655C1.66699 2.86313 1.66699 2.39642 1.84865 2.0399C2.00844 1.7263 2.2634 1.47133 2.57701 1.31154C2.93353 1.12988 3.40024 1.12988 4.33366 1.12988H10.0003C10.7769 1.12988 11.1652 1.12988 11.4715 1.25675C11.8798 1.42591 12.2043 1.75036 12.3735 2.15874C12.5003 2.46503 12.5003 2.85331 12.5003 3.62988M10.167 17.7966H15.667C16.6004 17.7966 17.0671 17.7966 17.4236 17.6149C17.7372 17.4551 17.9922 17.2001 18.152 16.8865C18.3337 16.53 18.3337 16.0633 18.3337 15.1299V9.62988C18.3337 8.69646 18.3337 8.22975 18.152 7.87323C17.9922 7.55963 17.7372 7.30466 17.4236 7.14487C17.0671 6.96322 16.6004 6.96322 15.667 6.96322H10.167C9.23357 6.96322 8.76686 6.96322 8.41034 7.14487C8.09674 7.30466 7.84177 7.55963 7.68198 7.87323C7.50033 8.22975 7.50033 8.69646 7.50033 9.62988V15.1299C7.50033 16.0633 7.50033 16.53 7.68198 16.8865C7.84177 17.2001 8.09674 17.4551 8.41034 17.6149C8.76686 17.7966 9.23357 17.7966 10.167 17.7966Z"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export const DoneIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="#667085"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>
    </SvgIcon>
  );
};

